exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboard-container {\n  width: 100%;\n}\n.dashboard-container .container {\n  width: 1200px;\n  margin: 0 auto;\n  padding: 24px 0 52px 0;\n}\n.last-btn {\n  margin: 10px 0 0 360px;\n}\n", ""]);

